//LOCAL STORAGE
function setItem(key: string, value: any) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    //@ts-ignore
    console.error('localStorage#setItem error: ' + error.message);
  }
}

function getItem(key: string) {
  const data = localStorage.getItem(key);
  let result: any | null = null;
  if (data !== null) {
    try {
      result = JSON.parse(data);
    } catch (e) {
      //@ts-ignore
      console.error('localStorage#getItem error deserializing JSON for key: ' + key, e.message);
    }
  } else {
    return undefined;
  }
  return result;
}

function removeItem(key: string) {
  return localStorage.removeItem(key);
}

export const StorageService = {
  get: getItem,
  set: setItem,
  remove: removeItem,
}
